var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map"},[_c('div',{attrs:{"id":"g-map"}}),_c('img',{staticClass:"location-icon",attrs:{"src":require("../../assets/imgs/location_icon.png"),"alt":""}}),_c('div',{staticClass:"location"},[_c('van-image',{attrs:{"src":require('@/assets/imgs/ic_location.png'),"width":".76rem"},on:{"click":_vm.onLocation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }